import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";

const SocialIcons = () => {
  const links = [
    {
      id: 1,
      child: (
        <>
          LinkedIn <FaLinkedin size={30} />
        </>
      ),
      href:'https://linkedin.com/in/nnaemeka-ogunewe-45379a167',
      style: 'rounded-tr-md'
    },
    {
      id: 2,
      child: (
        <>
          GitHub <FaGithub size={30} />
        </>
      ),
      href:'https://github.com/frankdev0',
    
    },
    {
      id: 3,
      child: (
        <>
          Mail <HiOutlineMail size={30} />
        </>
      ),
      href: 'mailto:nnaemekafrank400@gmail.com',
   
    },
    {
      id: 4,
      child: (
        <>
          Resume <BsFillPersonLinesFill size={30} />
        </>
      ),
      href:'/resume.pdf',
      style: 'rounded-br-md',
      download: true
    },
  ];

  return (
    <div className="hidden lg:flex flex-col top-[35%] left-0 fixed">
      <ul>
        {links.map(({child, id, download, href, style, }) => (
            <li key={id} className={`bg-gray-500 ml-[-100px] hover:ml-[-10px] duration-300 hover:rounded-md flex justify-center items-center w-40 h-14 px-4  ${style}`}>
          <a
            href={href}
            className="flex justify-between items-center w-full text-white"
            download={download}
            target='_blank'
            rel="noreferrer"
          >
            {child}
          </a>
        </li>

        ))}
        
      </ul>
    </div>
  );
};

export default SocialIcons;
